import React, { RefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Webcam from 'react-webcam';
import FlashlightOffIcon from '@mui/icons-material/FlashlightOff';
import FlashlightOnIcon from '@mui/icons-material/FlashlightOn';

import ToggleIconButton from '@ui-lib/components/ToggleIconButton';

interface Props {
	webcamRef: RefObject<Webcam | null>
}

const TorchToggle = ({ webcamRef }: Props) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const handleToggleTorch = async (enabled: boolean) => {
    // Get the video stream from the webcam component
    const stream = webcamRef.current?.video?.srcObject as MediaStream | null;
    if (!stream) return;

    // Get the video track from the stream
    const track = stream.getVideoTracks()[0];

    // Check if the device's camera supports the torch capability
    const capabilities = track.getCapabilities();
    if (!('torch' in capabilities) || !capabilities.torch) return;

    //Enable or disable the torch
    await track.applyConstraints({ advanced: [{ torch: enabled } as MediaTrackConstraintSet] });
    setActive(enabled);
  };

  return (
    <ToggleIconButton
      title={t('enableTorch')}
      testID='torch-toggle'
      active={active}
      onClick={() => handleToggleTorch(!active)}
      size='large'
    >
      {active ? <FlashlightOnIcon /> : <FlashlightOffIcon />}
    </ToggleIconButton>
  );
};

export default TorchToggle;
